
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisAtonMobileVirtualIec as ObiAisAtonMobileVirtualIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-aton-mobile-virtual-iec.js';
 
 
 

 
 export const ObiAisAtonMobileVirtualIec = createComponent({
   react: React,
   tagName: 'obi-ais-aton-mobile-virtual-iec',
   elementClass: ObiAisAtonMobileVirtualIecElement,
   events: {
     
   }
  });
 
 